import { Button, ButtonProps, useColorModeValue } from "@chakra-ui/react"
import { useFormikContext } from "formik"

const DiscardButton = (
  props: ButtonProps & { loading?: boolean; onDiscard?: () => void }
): JSX.Element => {
  const { loading, onDiscard, onClick, ...rest } = props
  const form = useFormikContext()
  const colorScheme = useColorModeValue("brand", undefined)
  const isLoading = loading || form.isSubmitting

  // Awaiting seems to ensure the form is validedted properly based
  // on the latest values.
  async function handleDiscard(e: React.MouseEvent<HTMLButtonElement>) {
    await form.resetForm()
    await form.validateForm()
    onDiscard?.()
    onClick?.(e)
  }

  return (
    <Button
      variant="solid"
      colorScheme={colorScheme}
      width="full"
      cursor="pointer"
      isDisabled={isLoading || !form.dirty}
      onClick={handleDiscard}
      {...rest}
    >
      {rest.children || "Discard"}
    </Button>
  )
}

export default DiscardButton
